import React from 'react';
import { useAgentHubContext } from '../contexts/AgentHubContext';

const TabWrapper = ({ children }) => {
  const context = useAgentHubContext();
  const { agent } = context || {};

  // Se não há agente, retorna apenas os filhos
  if (!agent) {
    return (
      <div className="tab-content-wrapper">
        {children}
      </div>
    );
  }

  // Injeta props do agente nos componentes filhos
  let enhancedChildren;
  try {
    if (React.isValidElement(children)) {
      enhancedChildren = React.cloneElement(children, {
        agentId: agent.id,
        selectedAgent: agent,
        contextAgent: agent,
        hubMode: true, // Flag para indicar que está no hub
        agentContext: agent // Usa o agente completo do contexto
      });
    } else {
      enhancedChildren = children;
    }
  } catch (error) {
    console.error('Error cloning element in TabWrapper:', error);
    enhancedChildren = children;
  }

  return (
    <div className="tab-content-wrapper">
      {enhancedChildren}
    </div>
  );
};

export default TabWrapper;